module.exports = __webpack_public_path__ + "static/media/cr-logo.66df1e31.png";